// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/**
 * URL di prod: https://apipromo.italonceramica.ru/api/
 * URL di dev/test: https://api-collections.italon.dotitsrl.it/api
 */
export const environment = {
  production: false,
  staging: false,
  baseUrl: "https://api-collections.italon.dotitsrl.it/api/",
  landingUrl: "https://landing.italon.dotitsrl.it/events/",
  home: "admin/collections",
  defaultLanguage: "it",
  gtmId: "GTM-XXXXXX",
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
